import { declareComponent } from '@/registry'
import { NullLoading } from '../ui/Loading'

export const OpenedLine = /*#__PURE__*/ declareComponent(
	'line-opened-line',
	'map-opened-line',
	() => import(/* webpackChunkName: 'map-opened-line' */ './OpenedLine'),
	NullLoading,
)

export const MapJourneysSwitch = /*#__PURE__*/ declareComponent(
	'journeys-map-journeys-switch',
	'map-map-journeys-switch',
	() =>
		import(
			/* webpackChunkName: 'map-map-journeys-switch' */ './MapJourneysSwitch'
		),
	NullLoading,
)

export const MapJourney = /*#__PURE__*/ declareComponent(
	'journeys-map-journey',
	'map-map-journey',
	() => import(/* webpackChunkName: 'map-map-journey' */ './MapJourney'),
	NullLoading,
)

export const CoordBuffer = /*#__PURE__*/ declareComponent(
	'coord-buffer',
	'map-coord-buffer',
	() =>
		import(
			/* webpackChunkName: 'map-coord-buffer' */ './Lines/CoordBuffer'
		),
	NullLoading,
)
export const EntryMap = /*#__PURE__*/ declareComponent(
	'entry-map',
	'map-entry-map',
	() =>
		import(
			/* webpackChunkName: 'map-entry-map' */ './render/EntryMap/EntryMap'
		),
	NullLoading,
)

export const EntryMapAround = /*#__PURE__*/ declareComponent(
	'entry-map-around',
	'map-entry-map-around',
	() =>
		import(
			/* webpackChunkName: 'map-entry-map-around' */ './render/EntryMap/EntryMapAround'
		),
	NullLoading,
)

export const PinArea = /*#__PURE__*/ declareComponent(
	'schedules-pin-area',
	'map-pin-area',
	() => import(/* webpackChunkName: 'map-pin-area' */ './PinArea'),
	NullLoading,
)

export const Boundary = /*#__PURE__*/ declareComponent(
	'around-boundary',
	'map-around-boundary',
	() => import(/* webpackChunkName: 'map-around-boundary' */ './Boundary'),
	NullLoading,
)

export const LinesAround = /*#__PURE__*/ declareComponent(
	'lines-around',
	'map-lines-around',
	() => import(/* webpackChunkName: 'map-lines-around' */ './LinesAround'),
	NullLoading,
)
